import { Component, OnInit, ViewChild } from '@angular/core';
import { LogService } from '../../services/log.service';
import { BaseForm } from '../../interfaces/BaseForm';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../../services/session.service';
import { NpsPanel } from 'app/types/nps-panel';
import { AuditService } from '../../services/audit.service';
import { SessionStorageService } from 'app/services/session-storage.service';
import { NPSScoringService } from 'app/services/nps-scoring.service';

@Component({
  selector: 'app-net-promoter-score',
  templateUrl: './net-promoter-score.component.html',
  styleUrls: ['./net-promoter.score.component.scss']
})
export class NetPromoterScoreComponent extends BaseForm implements OnInit {
  public defColor="numberCircle clrDefault";
  public userSelection="numberCircle clrSelect";
  public userChoice:Array<any> = [];
  public npsSelected=-1;
  public isSuccess;
  constructor(
    private log: LogService,
    private auditService: AuditService,
    private session: SessionService,
    private sessionStorage: SessionStorageService,
    public npsService: NPSScoringService,
    public activeModal: NgbActiveModal
   ) {
    super(log);
    this.npsSelected=-1;
    this.isSuccess=false;
  }
  ngOnInit() {
    this.clear();
    this.NpsInitializeModel()
  }
  onUserAction() {
    this.session.registerUserAction();
  }

  isValid(): boolean {
    console.log("isValid:"+this.npsSelected)
    if (this.npsSelected > -1 ) {
      return true;
    }
    return false;
  }
  isSubmitButtonClicked(): boolean {
    if(this.isSuccess){
      return true;
    }
    return false;
  }

  clear() {
    this.isSuccess = false;
  }
  NpsInitializeModel(){
    this.ClearModel()
    for (let npsScoreChoice = 0; npsScoreChoice< 10; npsScoreChoice++) {
      var choiceModel: NpsPanel={
        Id:``+ (npsScoreChoice+1),
        defColor:this.defColor,
        userSelection:this.userSelection,    
        OptionEntry:npsScoreChoice
        };
      this.userChoice[npsScoreChoice]=choiceModel
    }
  }
  ClearModel(){
    this.userChoice=[];
  }
  selectedSpan(event: any) {
    console.log("User clciked scoring scale");  
    let choiceSelected=event;
    this.npsSelected=choiceSelected;
    console.log(this.userChoice[choiceSelected].userSelection);
    this.NpsInitializeModel();
    this.userChoice[choiceSelected].defColor=this.userChoice[choiceSelected].userSelection;
   }
 
  SkipSurvey() {
    console.log("User skipped survey");
    this.auditService.auditEvent(
      this.session.getUser().username,
      'NPS-Score',
      'User skippped the survey:',
      { }
    );
    this.activeModal.dismiss();
  }
  close() {
    this.activeModal.close();
  }
  submit() {
    console.log("Submit button clicked")
    this.isSubmitInProgress = true;
    this.isSuccess = true;
    this.auditService.auditEvent(
      this.session.getUser().username,
      'NPS-Score',
      'User response:'+(this.npsSelected+1)+',User Comments:'+this.npsService.userComments,
      {
        organizationName: this.sessionStorage.getOrganization().OrganizationName,
        Facility: this.sessionStorage.getOrganization().Facilities,
        role: this.session.getUser().securityGroups
      }
    );
    this.startTimer2Sec(() => {
      this.activeModal.close();
    }); 
    this.npsService.userComments='';
  }
   
}
